import Stack from '@mui/material/Stack';
import { Outlet } from 'react-router-dom';
import DefaultAppHeader from '../../components/AppHeader/DefaultAppHeader';


export const AdminWrapper = () => {

    return (
        <>
            <DefaultAppHeader />
            <Stack direction="column" alignItems={'center'} spacing={2}>
                <Outlet />
            </Stack>
        </>
    );
};
